import { Box, HStack, Link, Text, VStack, View } from '@rbilabs/universal-components';

import { theme } from 'styles/configure-theme';

export const CardContainer = HStack.withConfig({
  backgroundColor: theme.token('background-pattern'),
  borderRadius: 'lg',
  paddingY: '$3',
  paddingX: '$4',
  width: 'full',
  alignItems: 'center',
});

export const thumbnailSize = {
  width: '$17.5',
  height: '$13.5',
};

export const ItemImageContainer = VStack.withConfig({
  alignItems: 'center',
});

export const Price = Text.withConfig({
  color: theme.token('text-disabled'),
  fontSize: 'sm',
  lineHeight: 'sm',
});

export const ItemName = Text.withConfig({
  fontFamily: 'heading',
  fontSize: 'md',
  lineHeight: '2xs',
  marginTop: '$1',
});

export const ItemThumbnailContainer = Box.withConfig({
  ...thumbnailSize,
  alignItems: 'center',
});

export const ThumbnailBox = View.withConfig({
  ...thumbnailSize,
  borderRadius: Styles.borderRadius,
  position: 'absolute',
  backgroundColor: Styles.color.grey.eleven,
  alignItems: 'center',
  shadow: 1,
  style: {
    shadowOpacity: 0.2,
    shadowRadius: 6,
  },
});

export const ThumbnailBehind = ThumbnailBox.withConfig({
  style: {
    shadowOpacity: 0.3,
    shadowRadius: 2,
  },
});

export const BadgeContainer = Box.withConfig({
  position: 'absolute',
  bottom: '$10',
  left: '$15',
  width: '$5',
  height: '$5',
});

export const StyledLink = Link.withConfig({
  _web: {
    width: 'fit-content',
    cursor: 'pointer',
    _hover: {
      _text: {
        color: Styles.color.tertiary,
      },
    },
  },
});
